export default defineNuxtRouteMiddleware((to, from) => {
  useFullscreenLoading().start()
})
